export default function isAuthenticated(){
    const authInfo = JSON.parse(localStorage.getItem('auth-info'));
    return new Date().getTime() < authInfo.authExpiresAt;
}